/* @import url('~survey-jquery/survey.css'); */
:host {
  font-family: var(--ai12z-font-family) !important;
  font-size: var(--ai12z-font-size) !important;
}
.not-allowed {
  cursor: not-allowed;
}

.ai12z-cta-link {
  color: var(--ai12z-link-color);
  text-decoration: underline;
}
.ai12z-cta-link:hover {
  color: var(--ai12z-link-hover-color);
}
@media (max-width: 768px) {
  .chat-align-list {
    padding: 1rem 1rem 1rem 0rem !important;
  }
  .chat-not-user-list {
    padding-inline-start: 2.5rem !important;
  }
}

.thumbs-up {
  /* fill: rgb(55 65 81); */
  fill: var(--ai12z-feedback-selected);
  width: 1.5rem;
}

.thumbs-down {
  fill: var(--ai12z-feedback-selected);
  width: 1.5rem;
}

.chat-thumbs-up {
  color: var(--ai12z-feedback-color);
}

.chat-list {
  margin-top: 1.25rem;
  overflow-y: auto;
  display: flex;
  max-height: 600px;
  flex-direction: column;
}

.custom-chat-top-height {
  /* max-height: 600px; */
  max-height: 100vh;
}

@media (max-width: 768px) {
  .custom-chat-bottom-height {
    max-height: 700px;
  }
  /* .custom-chat-top-height {
    max-height: 700px;
  } */
}
.custom-chat-bottom-height {
  max-height: 100%;
}
.custom-chat-above-height {
  max-height: 80vh;
  margin-bottom: 20px;
}
.custom-list {
  overflow-y: auto;
}

.chat-list-item {
  padding: 2rem 0.5rem 0 0.25rem;
  display: flex;
  position: relative;
  color: var(--ai12z-bubble-font-color);
  font-size: var(--ai12z-bubble-font-size);
}

.chat-align-list {
  justify-content: flex-start;
  padding-inline-end: 2.5rem;
}

.chat-not-user-list {
  justify-content: flex-end;
  padding-inline-start: 5rem;
}

.chat-inner-list {
  display: flex;
  align-items: flex-end;
  padding-right: 0.5rem;
}

.pending-chat {
  display: flex;
  justify-content: center;
  align-items: center;
  border-width: 1px;
  padding: 1.25rem;
  background-color: var(--ai12z-bubble-background);
  line-height: 1.75rem;
  border-radius: 0.5rem;
}

.non-pending-user {
  border-width: 1px;
  /* padding: 1rem; */
  background-color: var(--ai12z-bubble-background);
  line-height: 1.75rem;
  border-radius: 0.5rem;
}

.non-user-container {
  position: absolute;
  right: 0;
  top: 14px;
  /* height: 4rem; */
  width: 11rem;
}
.thumbnail {
  margin-bottom: 30px;
  width: 70%;
}
.ai12z_image_result {
  max-width: 500px;
  width: 100%;
  border-radius: 5%;
  padding: 20px;
}

.ai12z_image_caption {
  margin: 20px;
  padding: 1px;
  background-color: #f0f0f0;
  border-radius: 5px;
  text-align: center;
}
.resize {
  width: 100%;
}

.prose.prose-w-none * {
  all: unset; /* Example of resetting all styles */
}
.non-pending-user .ai12zBtn {
  background-color: var(--ai12z-hover-button-color);
  color: white;
  padding: 5px 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  text-decoration: none;
  margin: 5px;
}
.ai12zBtn:active {
  background-color: rgb(118 135 214);
}
/* WebKit-based browsers (Chrome, Safari, Edge) */
::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 10px;
  border: 2px solid #f1f1f1;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.copy-btn {
  /* width: 30%; */
  color: var(--ai12z-feedback-color);
}
.list-btn {
  background-color: #007bff;
  color: white;
  padding: 5px 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  text-decoration: none;
  margin: 5px;
  max-width: 100%;
  /* width: 45%; */
}
.pagination-controls {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.pagination-controls button {
  padding: 10px 20px;
  border: none;
  background-color: #007bff;
  color: white;
  cursor: pointer;
  border-radius: 5px;
}

.pagination-controls button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.pagination-controls span {
  align-self: center;
  font-size: 1.1em;
}
.hidden {
  display: none;
}

.carousel-container {
  position: relative;
  display: flex;
  overflow: hidden;
  margin: 0 auto;
  width: 100%;
  max-width: 100%;
}
.carousel-items {
  display: flex;
  transition: transform 0.3s ease-in-out;
  width: 100%;
}
.carousel-card {
  flex-shrink: 0;
  width: 100%;
}
.card img {
  width: 100%;
  height: auto;
}
.card-body {
  margin: 15px;
}
.prev,
.next {
  background: #007bff;
  border: none;
  color: white;
  padding: 10px;
  cursor: pointer;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
}

.prev {
  cursor: pointer;
  left: 0px;
}

.next {
  cursor: pointer;
  right: 0px;
}
.carousel-indicators {
  display: flex;
  justify-content: center;
  margin-top: 10px;
  bottom: 4px;
  left: 50%;
}

.indicator {
  width: 10px;
  height: 10px;
  background-color: gray;
  border-radius: 50%;
  margin: 0 5px;
  cursor: pointer;
}
